// src/components/Sidebar.jsx
import React from "react";
import Icon from "./Icon";

function SidebarLink({ item, activeKey, onChange }) {
  const isActive = activeKey === item.key;
  return (
    <button
      onClick={() => onChange(item.key)}
      className={`flex items-center gap-3 w-full text-left px-4 py-3 rounded-xl transition hover:bg-blue-50 ${
        isActive ? "bg-blue-100 text-blue-700" : "text-slate-700"
      }`}
    >
      <Icon name={item.icon} className="w-5 h-5" />
      <span className="font-medium">{item.label}</span>
    </button>
  );
}

/**
 * props:
 * - items: array { key, label, icon }
 * - active: string (key menu aktif)
 * - onChange: (key) => void
 */
export default function Sidebar({ items, active, onChange }) {
  return (
    <aside className="col-span-12 md:col-span-3 lg:col-span-2">
      <nav className="bg-white rounded-2xl border border-slate-100 p-2 space-y-1">
        {items.map((item) => (
          <SidebarLink
            key={item.key}
            item={item}
            activeKey={active}
            onChange={onChange}
          />
        ))}
      </nav>
    </aside>
  );
}
